import React, { useState } from "react";
import SizeGuideModal from "./SizeGuideModal";

const ALL_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];

export default function SizeSelector({ sizes = ALL_SIZES, outOfStock = [], value, onChange, showGuide = true }) {
  const [guideOpen, setGuideOpen] = useState(false);
  return (
    <div data-testid="size-selector">
      <div className="flex items-center justify-between mb-3">
        <span className="font-mono text-[0.65rem] tracking-mt uppercase" style={{ color: "var(--mt-text-muted)" }}>
          Size
        </span>
        {showGuide && (
          <button
            type="button"
            onClick={() => setGuideOpen(true)}
            className="font-mono text-[0.62rem] tracking-mt uppercase opacity-70 hover:opacity-100 underline underline-offset-4"
            data-testid="size-guide-open"
          >
            Size Guide
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {ALL_SIZES.map((s) => {
          const available = sizes.includes(s);
          const oos = outOfStock.includes(s) || !available;
          return (
            <button
              key={s}
              type="button"
              onClick={() => !oos && onChange(s)}
              className="mt-pill min-w-[54px]"
              data-active={value === s}
              data-oos={oos}
              data-testid={`size-${s}`}
              disabled={oos}
            >
              {s}
            </button>
          );
        })}
      </div>
      <SizeGuideModal open={guideOpen} onClose={() => setGuideOpen(false)} />
    </div>
  );
}
